var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","widht":"100%","height":"100%","margin":"0"}},[_c('fa-icon',{staticClass:"rotating",attrs:{"icon":['fas', 'spinner-third']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }